export default "__VITE_ASSET__31e9b5a8__"